import { canv } from "@/canv/global";
import { Button } from "@/shared/ui/Button";

type Props = {
    className?: string;
    teamId: string;
};

export const UpgradeTariffButton = ({ className, teamId }: Props) => {
    const handleUpgradeTariffButtonClick = () => {
        // TODO: сделать сразу ссылкой?
        if (!teamId) return;
        window.open(`${canv.host}/dashboard?need_tariff_payment=true&teamId=${teamId}`, "_blank");
    };

    return (
        <Button className={className} variant="secondary" onClick={handleUpgradeTariffButtonClick}>
            Улучшить тариф
        </Button>
    );
};
